import { Box, Link as MuiLink, Typography } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { Fragment } from "react";
import { Link } from "react-router-dom";

import { CALIBRATE_COLORS } from "components/hoc/Theme";

export interface Crumb {
  label: string;
  /** Left out for the current page. */
  to?: string;
  /** False when the chevron must not lead here. */
  back?: boolean;
}

/** "< Secure Exchange / Client / Project": the chevron goes one level up, and the
 * page one level up is set in semibold. */
export default function SecureExchangeBreadcrumbs({
  items,
}: {
  items: Crumb[];
}) {
  const up = items.length > 1 ? items[items.length - 2] : undefined;
  return (
    <Box
      component="nav"
      aria-label="Breadcrumbs"
      sx={{
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.5,
        fontSize: 12,
        color: CALIBRATE_COLORS.secondaryText,
      }}
    >
      {up?.to && up.back !== false ? (
        <MuiLink
          component={Link}
          to={up.to}
          aria-label={`Back to ${up.label}`}
          sx={{ display: "flex", color: "inherit" }}
        >
          <ChevronLeft sx={{ fontSize: 18 }} />
        </MuiLink>
      ) : null}
      {items.map((item, index) => {
        const weight = item === up ? 600 : 400;
        return (
          <Fragment key={`${index}-${item.label}`}>
            {index > 0 ? <span aria-hidden>/</span> : null}
            {item.to && index < items.length - 1 ? (
              <MuiLink
                component={Link}
                to={item.to}
                underline="hover"
                sx={{ color: "text.primary", fontWeight: weight, fontSize: 12 }}
              >
                {item.label}
              </MuiLink>
            ) : (
              <Typography
                component="span"
                sx={{ fontSize: 12, fontWeight: weight, color: "text.primary" }}
              >
                {item.label}
              </Typography>
            )}
          </Fragment>
        );
      })}
    </Box>
  );
}
